import { useState } from "react";
import { BellOff, MessageCircle, X } from "lucide-react";
import { toast } from "sonner";

import { desligarFila, dispensarCliente } from "./filaAtendimento";
import { useFilaAtendimento } from "./useFilaAtendimento";

function tempoEsperando(segundos) {
  const min = Math.floor((segundos || 0) / 60);
  return min < 1 ? "agora" : `${min} min`;
}

function mensagemDeErro(e, padrao) {
  if (e?.response?.status === 403) return e.response.data?.detail || "Você não tem permissão para desligar a fila";
  return padrao;
}

function ClienteNaFila({ cliente, onDispensar }) {
  return (
    <li className="group flex items-start gap-2 px-4 py-2.5 hover:bg-muted/50">
      <MessageCircle className="w-4 h-4 mt-0.5 shrink-0 text-red-500" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="text-sm font-medium truncate">{cliente.push_name || "Cliente"}</span>
          <span className="text-[11px] tabular-nums text-muted-foreground shrink-0">
            {tempoEsperando(cliente.waiting_time_seconds)}
          </span>
        </div>
        <p className="text-xs text-muted-foreground tabular-nums">{cliente.phone}</p>
        {cliente.message && (
          <p className="text-xs text-muted-foreground truncate">"{cliente.message}"</p>
        )}
      </div>
      <button
        type="button"
        onClick={() => onDispensar(cliente.phone)}
        className="p-1 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted shrink-0"
        title="Já atendi — tirar da fila"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </li>
  );
}

/** Seção "aguardando atendimento" do sino do cabeçalho. Não renderiza nada com a fila vazia. */
export default function ListaFilaAtendimento() {
  const { quantidade, clientes } = useFilaAtendimento();
  const [desligando, setDesligando] = useState(false);
  if (quantidade === 0) return null;

  const dispensar = async (phone) => {
    try {
      await dispensarCliente(phone);
    } catch (e) {
      toast.error(mensagemDeErro(e, "Não foi possível tirar o cliente da fila"));
    }
  };
  const desligar = async () => {
    setDesligando(true);
    try {
      await desligarFila();
    } catch (e) {
      toast.error(mensagemDeErro(e, "Não foi possível desligar a notificação"));
    } finally {
      setDesligando(false);
    }
  };

  return (
    <div className="border-b">
      <div className="px-4 py-2 bg-red-500/10 flex items-center justify-between gap-2">
        <p className="text-xs font-semibold text-red-600 dark:text-red-400">
          {quantidade} {quantidade === 1 ? "cliente aguardando" : "clientes aguardando"} atendimento
        </p>
        <button
          type="button"
          onClick={desligar}
          disabled={desligando}
          className="flex items-center gap-1 text-[11px] font-medium text-red-600 dark:text-red-400 hover:underline disabled:opacity-50"
          title="Tira todos da fila e para o som"
        >
          <BellOff className="w-3 h-3" />
          Desligar
        </button>
      </div>
      <ul className="max-h-72 overflow-y-auto divide-y divide-border/60">
        {clientes.map((c) => (
          <ClienteNaFila key={c.phone} cliente={c} onDispensar={dispensar} />
        ))}
      </ul>
    </div>
  );
}
